import { Dialog, DialogContent, DialogTrigger } from "components/ui/dialog";
import { IconProps } from "components/icon/Icon";
import { ModalHeader } from "./ModalHeader";
import { ModalFooter } from "./ModalFooter";
import { ModalProps, ModalVariant } from "./Modal.types";

const variantDefaults: Record<ModalVariant, { iconName: IconProps["name"] }> = {
  primary: { iconName: "zap" },
  warning: { iconName: "triangle-alert" },
  danger: { iconName: "octagon-alert" },
};

export function Modal({
  id,
  open,
  loading = false,
  onOpenChange,
  onConfirm,
  title,
  description,
  confirmLabel,
  confirmIconName,
  cancelLabel,
  cancelIconName,
  mainIconName,
  variant,
  children,
  confirmVariant,
  confirmClassName,
  disabledConfirm,
  trigger,
}: ModalProps) {
  const { iconName: defaultIconName } = variantDefaults[variant];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {trigger && <DialogTrigger asChild>{trigger}</DialogTrigger>}
      <DialogContent
        className="py-12 px-12 w-auto min-w-[550px]"
        data-testid={`${id}-modal`}
      >
        <ModalHeader
          title={title}
          description={description}
          iconName={mainIconName || defaultIconName}
          variant={variant}
        />
        {children}
        <ModalFooter
          id={id}
          confirmLabel={confirmLabel}
          confirmIconName={confirmIconName}
          confirmVariant={confirmVariant || variant}
          confirmClassName={confirmClassName}
          cancelLabel={cancelLabel}
          cancelIconName={cancelIconName}
          loading={loading}
          disabledConfirm={disabledConfirm}
          onConfirm={onConfirm}
        />
      </DialogContent>
    </Dialog>
  );
}
